import { InteractionRequiredAuthError } from "@azure/msal-browser";
import axios from "axios";
import { useState, useEffect } from "react";
import { AccessToken } from "../../config/AccessToken";

export const AlarmsTile = () => {

    const SERVER_URL = process.env.REACT_APP_SERVER_URL;
    const [error, setError] = useState('');
    const [instance, accessTokenRequest] = AccessToken();
    let languageId = localStorage.getItem('languageId');       

    const [counterAlarms, setCounterAlarms] = useState([]);

    useEffect(() => {
      getAlarmCounter();
    }, []);
  
    const getAlarmCounter = async () => {

      const commonOperations = (accessToken: any) => {
        const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId  };
        axios.get(`${SERVER_URL}/alarm/count`, { headers })
          .then((res) => {
            const data = res?.data
            setCounterAlarms(data?.data?.alarmCount);
          }).catch((data) => {
            setError(data?.message);
          });
      }
  
      if (localStorage.getItem('accessToken') != null) {
        let accessToken = localStorage.getItem('accessToken');
        commonOperations(accessToken);
      } else {
        await instance.initialize();
        await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
          // Acquire token silent success
          let accessToken = accessTokenResponse.accessToken;
          commonOperations(accessToken);
        })
          .catch((error: any) => {
            if (error instanceof InteractionRequiredAuthError) {
              instance.acquireTokenRedirect(accessTokenRequest);
            }
            console.log(error);
          });
      }
    }
   
    return (
      <div style={{containerType: 'inline-size'}}>                    
        <div className="dashboard-card-content total-alarm" >
          <p className="dashboard-card-content-number total-alarm blue">{counterAlarms}</p>      
          {/* { (rowSpan > 1 || colSpan > 1) ? <img src={logo} alt="Test" style={{ width: '100%', height: 'auto' }} /> : null } */}
        </div>
      </div>      
    );
  };